import { SCRIPT_KEY, WIDGET_SRC } from '../components/misc/HelpdeskWidget';

const TOKEN_KEY = 'gise_panel_access_token';

const helpdeskApiBase = () => {
  try {
    return new URL(WIDGET_SRC).origin;
  } catch {
    return 'https://api.prasolmedia.com';
  }
};

const request = async (path) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    const error = new Error('auth required');
    error.status = 401;
    throw error;
  }
  const response = await fetch(`${helpdeskApiBase()}${path}`, {
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    const raw = data?.message;
    const error = new Error(Array.isArray(raw) ? raw[0] : raw || 'error');
    error.status = response.status;
    throw error;
  }
  return data;
};

/** Panel kullanıcısının (işletme kanalı) destek talepleri */
export const listMySupportTickets = () =>
  request(`/widget/my-tickets?key=${encodeURIComponent(SCRIPT_KEY)}`);

export const getMySupportTicket = (ticketHash) =>
  request(
    `/widget/my-tickets/${encodeURIComponent(ticketHash)}?key=${encodeURIComponent(SCRIPT_KEY)}`,
  );

/**
 * Staff TR yazar, backend yanıt anındaki müşteri diline çevirir ({ tr, <müşteri dili> }).
 * Müşteri dili sohbet içinde değişebildiği için önce o çeviri, UI dili değil.
 */
export const customerMessageText = (message, ticketLanguage) => {
  if (!message) return '';
  if (!message.isStaff || !message.translations) return message.message;
  const tx = message.translations;
  const customerKey = Object.keys(tx).find((k) => k !== 'tr' && tx[k]);
  if (customerKey) return tx[customerKey];
  const tl = String(ticketLanguage || '').toLowerCase();
  return (tl && tx[tl]) || message.message;
};
